import styled from 'styled-components';

const ThreadLoadingText = styled.p``;

export default ThreadLoadingText;
